import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const Clock = ({ color, big }) => {
  return (
    <svg width={big ? "102px" : "51px"} height={big ? "102px" : "51px"} viewBox="0 0 51 51" version="1.1">
      <defs>
        <path
          d="M11.5,0 C5.152,0 0,5.152 0,11.5 C0,17.848 5.152,23 11.5,23 C17.848,23 23,17.848 23,11.5 C23,5.152 17.848,0 11.5,0 Z M11.04,2.3 C11.04,2.024 11.224,1.84 11.5,1.84 C11.776,1.84 11.96,2.024 11.96,2.3 L11.96,3.22 C11.96,3.496 11.776,3.68 11.5,3.68 C11.224,3.68 11.04,3.496 11.04,3.22 L11.04,2.3 Z M3.22,11.96 L2.3,11.96 C2.024,11.96 1.84,11.776 1.84,11.5 C1.84,11.224 2.024,11.04 2.3,11.04 L3.22,11.04 C3.496,11.04 3.68,11.224 3.68,11.5 C3.68,11.776 3.496,11.96 3.22,11.96 Z M5.98,17.664 L5.336,18.308 C5.152,18.492 4.876,18.492 4.692,18.308 C4.508,18.124 4.508,17.848 4.692,17.664 L5.336,17.02 C5.52,16.836 5.796,16.836 5.98,17.02 C6.164,17.204 6.164,17.48 5.98,17.664 Z M5.98,5.98 C5.796,6.164 5.52,6.164 5.336,5.98 L4.692,5.336 C4.508,5.152 4.508,4.876 4.692,4.692 C4.876,4.508 5.152,4.508 5.336,4.692 L5.98,5.336 C6.164,5.52 6.164,5.796 5.98,5.98 Z M11.96,20.7 C11.96,20.976 11.776,21.16 11.5,21.16 C11.224,21.16 11.04,20.976 11.04,20.7 L11.04,19.78 C11.04,19.504 11.224,19.32 11.5,19.32 C11.776,19.32 11.96,19.504 11.96,19.78 L11.96,20.7 Z M16.1,11.96 L11.5,11.96 C11.224,11.96 11.04,11.776 11.04,11.5 L11.04,6.9 C11.04,6.624 11.224,6.44 11.5,6.44 C11.776,6.44 11.96,6.624 11.96,6.9 L11.96,11.04 L16.1,11.04 C16.376,11.04 16.56,11.224 16.56,11.5 C16.56,11.776 16.376,11.96 16.1,11.96 Z M18.308,18.308 C18.124,18.492 17.848,18.492 17.664,18.308 L17.02,17.664 C16.836,17.48 16.836,17.204 17.02,17.02 C17.204,16.836 17.48,16.836 17.664,17.02 L18.308,17.664 C18.492,17.848 18.492,18.124 18.308,18.308 Z M18.308,5.336 L17.664,5.98 C17.48,6.164 17.204,6.164 17.02,5.98 C16.836,5.796 16.836,5.52 17.02,5.336 L17.664,4.692 C17.848,4.508 18.124,4.508 18.308,4.692 C18.492,4.876 18.492,5.152 18.308,5.336 Z M20.7,11.96 L19.78,11.96 C19.504,11.96 19.32,11.776 19.32,11.5 C19.32,11.224 19.504,11.04 19.78,11.04 L20.7,11.04 C20.976,11.04 21.16,11.224 21.16,11.5 C21.16,11.776 20.976,11.96 20.7,11.96 Z"
          id="path-clock"
        />
        <filter
          x="-100.0%"
          y="-82.6%"
          width="300.0%"
          height="300.0%"
          filterUnits="objectBoundingBox"
          id="filter-clock"
        >
          <feOffset
            dx="0"
            dy="4"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="7"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.443137255   0 0 0 0 0.843137255   0 0 0 0 0.48627451  0 0 0 0.409250453 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g
        id="desktop-clock"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="filled-clock" transform="translate(-1096.000000, -82.000000)">
          <g
            id="filled-nested-clock"
            transform="translate(1110.000000, 92.000000)"
          >
            <g id="Shape-clock">
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-clock)"
                xlinkHref="#path-clock"
              />
              <use fill={color} fillRule="evenodd" xlinkHref="#path-clock" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

Clock.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

Clock.propTypes = {
  color: PropTypes.string
}

export default Clock
